import React from "react";
import { FaLinkedin, FaTwitter, FaGithub } from "react-icons/fa";
import { SiGmail } from "react-icons/si";

export const Footer = () => {

  const socialLinks = [
    {
      name: "LinkedIn",
      icon: <FaLinkedin />,
      href: "https://in.linkedin.com/in/akash-perumal-954106117",
      color: "hover:text-blue-400"
    },
    {
      name: "Twitter",
      icon: <FaTwitter />,
      href: "https://www.twitter.com/codewithsky",
      color: "hover:text-blue-300"
    },
    {
      name: "GitHub",
      icon: <FaGithub />,
      href: "https://github.com/codewithsky-in",
      color: "hover:text-gray-300"
    },
    {
      name: "Email",
      icon: <SiGmail />,
      href: "mailto:codewithsky.in@gmail.com",
      color: "hover:text-red-400"
    }
  ];

  return (
    <footer id="contact" className="bg-black/40 backdrop-blur-md border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold text-white" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
            </h3>
            <p className="text-gray-400 leading-relaxed" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
              A tech enthusiast who loves to code and explore new technologies while capturing beautiful moments through photography.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
              Quick Links
            </h4>
            <div className="space-y-2">
              <a href="#about" className="block text-slate-400 hover:text-blue-400 transition-colors hover:shadow-lg hover:shadow-blue-500/20" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
                About Me
              </a>
              <a href="#journey" className="block text-slate-400 hover:text-blue-400 transition-colors hover:shadow-lg hover:shadow-blue-500/20" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
                My Journey
              </a>
              <a href="#projects" className="block text-slate-400 hover:text-blue-400 transition-colors hover:shadow-lg hover:shadow-blue-500/20" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
                Projects
              </a>
              <a href="/resume" className="block text-slate-400 hover:text-blue-400 transition-colors hover:shadow-lg hover:shadow-blue-500/20" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
                Resume
              </a>
            </div>
          </div>

          {/* Contact & Social */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
              Get In Touch
            </h4>
            <p className="text-gray-400" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
              Let's connect and create something amazing together!
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  className={`p-3 bg-white/10 backdrop-blur-sm rounded-full text-white/80 ${social.color} transition-all duration-300 hover:scale-110 hover:bg-white/20`}
                  title={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
